import { withInstall } from '@hd-front-end/utils'
import Tree from './src/tree.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElTree: SFCWithInstall<typeof Tree> = withInstall(Tree)

export default ElTree

export * from './src/tree.type'
export * from './src/instance'
export * from './src/tokens'
